// export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://api.clundman.test/' : 'https://api.clundman.com/';
export const contentAPI = 'https://api.clundman.com/';

export const origin = 'https://www.clundman.com';

export const urlRoots = ['clundman'];

export const useLanguageURLRoots = false;
